import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import MenuLateral from "../Components/MenuPrincipal/MenuLateral";
import InsumoForm from "../Components/insumoForm/insumoForm";
import { useAuth } from "../Context/auth";
import './Insumos.css';

function EditarInsumo() {
    const { currentUser } = useAuth();
    const navigate = useNavigate();
    const { id: insumoId } = useParams();
    const [initialData, setInitialData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [mensagem, setMensagem] = useState('');

    useEffect(() => {
        if (!insumoId || !currentUser) return;
        const buscarInsumo = async () => {
            setLoading(true);
            try {
                const token = await currentUser.getIdToken();
                const API_URL = process.env.REACT_APP_API_URL;
                const response = await fetch(`${API_URL}/api/insumos/${insumoId}`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                if (!response.ok) throw new Error('Insumo não encontrado ou acesso negado.');
                const data = await response.json();
                setInitialData(data);
            } catch (error) {
                console.error("Erro ao carregar o insumo:", error);
                setMensagem(error.message);
            } finally {
                setLoading(false);
            }
        };
        buscarInsumo();
    }, [insumoId, currentUser]);

    async function handleEditar(formData) {
        setMensagem('');
        setLoading(true);
        try {
            const token = await currentUser.getIdToken();
            const API_URL = process.env.REACT_APP_API_URL;
            const response = await fetch(`${API_URL}/api/insumos/${insumoId}`, {
                method: 'PUT',
                confirmButtonColor: '#2185c6',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                body: JSON.stringify(formData)
            });
            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || "Erro ao atualizar insumo.");
            }
            navigate('/app/insumos');
        } catch (erro) {
            setMensagem(erro.message);
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className="insumos-page-container" style={{ display: 'flex', paddingTop: 0 }}>
            <MenuLateral />

            <div className="content-with-sidebar">
                <div className="insumos-header">
                    <div className="d-flex align-items-center gap-3">
                        <button className="btn btn-link text-secondary p-0" onClick={() => navigate('/app/insumos')} title="Voltar">
                            <i className="fas fa-arrow-left fa-lg"></i>
                        </button>
                        <h1 className="insumos-title m-0">
                            Editar <span className="highlight">Insumo</span>
                        </h1>
                    </div>
                </div>

                <main className="insumos-content">
                    {mensagem && initialData && (
                        <div className="alert alert-danger mb-4 d-flex align-items-center">
                            <i className="fas fa-exclamation-circle me-2"></i> {mensagem}
                        </div>
                    )}

                    {loading && (
                        <div className="text-center py-5">
                            <div className="spinner-border text-primary" role="status"></div>
                            <p className="mt-2 text-muted">Carregando dados...</p>
                        </div>
                    )}

                    {!loading && initialData && (
                        <InsumoForm
                            initialData={initialData}
                            onSubmit={handleEditar}
                            isEditing={true}
                            loading={loading}
                        />
                    )}

                    {!loading && !initialData && (
                        <div className="alert alert-warning">
                            Insumo não encontrado ou você não tem permissão para vê-lo.
                        </div>
                    )}
                </main>
            </div>
        </div>
    );
}

export default EditarInsumo;